import { sspApi } from 'yxt-biz-pc/packages/api';

// 获取用户积分
export const getUserPointData = (userId) => {
  return sspApi.get(`user/point/${userId}`);
};

// 打赏
export const putPointData = (data) => {
  return sspApi.put('user/point/move', data);
};

// 获取用户积分
export const getPointSelf = (data) => {
  return sspApi.get('user/point/self', data);
};
